var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpgList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h32v32h-32z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,18.667H9.333V13.333H4V18.667ZM4,25.333H9.333V20H4V25.333ZM4,12H9.333V6.667H4V12ZM10.667,18.667H28V13.333H10.667V18.667ZM10.667,25.333H28V20H10.667V25.333ZM10.667,6.667V12H28V6.667H10.667Z",
    fill: "#909BF1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpgList);
export default __webpack_public_path__ + "static/media/spgList.7e2216acfdc67876e1538d87c2c56a67.svg";
export { ForwardRef as ReactComponent };